// Reveal
Drupal.behaviors.sw_form_user_register = {
  attach: function( context, settings ) {
    $(once('sw_form_user_register', '.form-user-register', context)).each(function() {
      const r = new FormUserRegister($(this));
    });
  }
}

class FormUserRegister {
  constructor($wrap) {
    const _this = this;
    this.$wrap = $wrap;
    this.$plan_checkboxes = this.$wrap.find('.form-user-register__plan-checkbox');
    this.$plan_submit = this.$wrap.find('input[name="op_plan_apply"]');

    this.$plan_checkboxes.on('change', function( e ) {
      _this.plan_submit();
    });
  }
  plan_submit() {
    this.$plan_submit.trigger('mousedown');
  }
}
